$(() => {
    const $recWrapper = $('.job-recommender-jobs-wrapper');
    const $list = $('.job-recommender-job-list');
    const $nullState = $('.job-recommender-null-state');
    const $rateLimitedState = $('.job-recommender-rate-limited-state');
    const $header = $('header#topnav');
    let numberOfJobsActivated = 0;
    const skipFirstAutoScroll = $recWrapper.get(0)?.hasAttribute('data-skip-first-auto-scroll') ?? false;

    /**
     * Determine if the page should automatically be scrolled to the top of the active job card
     */
    const shouldAutoScroll = () => {
        if (!skipFirstAutoScroll || numberOfJobsActivated > 0) {
            /**
             * In some instances we want to skip scrolling for the first activation because we're
             * selecting the first job programatically. Specifically, this happens on the inactive jobs recommender
             * where we have a banner we want the user to see at the top of the page.
             */
            return true;
        }

        return false;
    };

    if ($list.length) {
        // Not sure how/why there wouldn't be a list component, but it doesn't hurt to be safe
        $list.on('scroll', function() {
            const $this = $(this);
            let threshold = 750;

            if ($this.data('infScrollThreshold')) {
                threshold = parseInt($this.data('infScrollThreshold'));
            }

            const bottomOfCurrentView = $this.scrollTop() + $this.innerHeight();
            const actualBottomOfDiv = $this.prop('scrollHeight');

            if (bottomOfCurrentView + threshold >= actualBottomOfDiv) {
                const evt = new CustomEvent('job-recommender:list:more-jobs');
                document.dispatchEvent(evt);
            }
        });
    }

    $recWrapper.on('job-recommender:list:active', function(evt) {
        const jobId = evt.detail.jobId;
        const $card = $(`.recommended-job[data-job-id="${jobId}"]`);
        const $this = $(this);

        if (shouldAutoScroll()) {
            /**
             * Animate the _wrapper_ to scroll the job card to the top of the wrapper.
             */
            $this.animate({
                scrollTop: $card.offset().top - $this.offset().top + $this.scrollTop(),
            }, 300);

            /**
             * In case the recommended jobs wrapper isn't already aligned in the viewport, we want to make sure that it
             * is set to the top so the user can see the job card that was scrolled to (above).
             * On mobile, the header sticks to the top of the page, so we need to account for that and make sure the
             * active job card, and recommender are below that header.
             */
            const stickyHeaderActive = $header.length ? $header.css('position') === 'fixed' : false;
            const topBuffer = stickyHeaderActive ? $header.height() : 0;
            $('html').animate({
                scrollTop: $this.offset().top - topBuffer,
            }, 300);
        }

        numberOfJobsActivated++;
    });

    $(document).on('job-recommender:list:recommendations-available', () => {
        $recWrapper.show();
        $nullState.hide();
    });

    $(document).on('job-recommender:list:recommendations-unavailable', () => {
        $recWrapper.hide();
        $nullState.show();
    });

    $(document).on('job-recommender:daily-limit-reached', () => {
        $recWrapper.hide();
        $nullState.hide();
        $rateLimitedState.removeClass('d-none').show();
    });
});
